/**
 * Resolução global da URL da API.
 *
 * Prioridade:
 * 1) window.CONDOFLEX_CONFIG.API_URL (public/config.js — runtime, sem rebuild)
 * 2) process.env.REACT_APP_API_URL (build CRA / .env.production na pipeline)
 * 3) Auto-detecção pelo hostname (ex.: horizonecondo... → api.horizonecondo.../api)
 */

const trimSlash = (value = "") => String(value).trim().replace(/\/+$/, "");

/** Garante sufixo /api sem duplicar. */
export function normalizeApiUrl(raw) {
  const base = trimSlash(raw);
  if (!base) return "";
  if (base.endsWith("/api")) return base;
  return `${base}/api`;
}

function readRuntimeConfigUrl() {
  if (typeof window === "undefined") return "";
  const cfg = window.CONDOFLEX_CONFIG;
  const url = cfg?.API_URL;
  if (url == null || url === "") return "";
  return normalizeApiUrl(url);
}

function readBuildEnvUrl() {
  return normalizeApiUrl(process.env.REACT_APP_API_URL || "");
}

/** Inferência para dev/LAN/produção quando não há env no bundle. */
function detectApiUrlFromLocation() {
  if (typeof window === "undefined") return "";
  const { protocol, hostname } = window.location;

  // Front em subdomínio público → API em api.<mesmo-domínio>
  if (hostname && !hostname.startsWith("api.") && !hostname.startsWith("api-")) {
    const apiHost = hostname.replace(/^www\./i, "");
    if (apiHost.includes(".")) {
      return normalizeApiUrl(`${protocol}//api.${apiHost}`);
    }
  }

  // Local / LAN: mesma máquina, porta 3001
  const host = hostname || "localhost";
  return normalizeApiUrl(`${protocol}//${host}:3001`);
}

let cachedBase = null;

export function resolveApiBaseUrl() {
  const runtime = readRuntimeConfigUrl();
  if (runtime) return runtime;

  const fromEnv = readBuildEnvUrl();
  if (fromEnv) return fromEnv;

  return detectApiUrlFromLocation();
}

export function getApiBaseUrl() {
  if (cachedBase == null) {
    cachedBase = resolveApiBaseUrl();
    if (process.env.NODE_ENV === "development" && !cachedBase) {
      console.warn("[eCondo] REACT_APP_API_URL vazia e sem CONDOFLEX_CONFIG.API_URL.");
    }
  }
  return cachedBase;
}

/** Força nova leitura (útil após editar config.js e F5). */
export function resetApiBaseCache() {
  cachedBase = null;
}

export function getApiOrigin() {
  return getApiBaseUrl().replace(/\/api$/, "");
}

/** Validação para diagnóstico (login / boot). */
export function getApiConfigDiagnostics() {
  const runtime = readRuntimeConfigUrl();
  const build = readBuildEnvUrl();
  const detected = detectApiUrlFromLocation();
  const active = getApiBaseUrl();
  return {
    active,
    source: runtime ? "CONDOFLEX_CONFIG" : build ? "REACT_APP_API_URL" : "auto-detect",
    runtime: runtime || null,
    build: build || null,
    detected: detected || null,
  };
}
